import { Component, inject, OnDestroy } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { AuthenticationService } from '../../../core/services/authentication.service';
import { EmployeeService } from '../../../employee/services/employee.service';
import { UserService } from '../../../setting/services/user.service';
import { FlatpickrHelper } from '../../../shared/common/FlatpickrHelper';
import { SummernoteHelper } from '../../../shared/common/SummernoteHelper';
import { FlatpickrLocaleService } from '../../../shared/services/flatpickr-locale.service';

@Component({
    template: ''
})

// abstract to have the most used things in one place
export abstract class ParentOfComponent implements OnDestroy {
    protected readonly fb = inject(UntypedFormBuilder);
    protected readonly summernoteHelper = inject(SummernoteHelper);
    protected readonly fpHelper = inject(FlatpickrHelper);
    protected readonly translateService = inject(TranslateService);
    protected readonly modalService = inject(NgbModal);
    protected readonly authService = inject(AuthenticationService);
    protected readonly employeeService = inject(EmployeeService);
    protected readonly userService = inject(UserService);
    protected readonly flatpickrLocale = inject(FlatpickrLocaleService);
    protected readonly locale$ = this.flatpickrLocale.currentFlatpickrLocale$;
    protected readonly subscriptions = new Subscription();

    protected constructor() { }

    public ngOnDestroy(): void {
        this.subscriptions?.unsubscribe();
    }
}
